// Ez a komponens a főoldal megjelenítéséért felelős

import React from 'react';
import { Box } from '@mui/material';
import HeroBanner from '../components/HeroBanner';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <Box>
      <HeroBanner />
      <Box sx={{ pb: '250px' }} /> {/* Hely a kép és a footer között */}
    </Box>
  );
};

export default Home;
